import { combineEpics } from "redux-observable";
import { upsellMessageDismissEpicReducer } from "../ducks/index.js";
const upsellMessageDismissEpic = combineEpics(upsellMessageDismissEpicReducer.epic);
export {
  upsellMessageDismissEpic
};
//# sourceMappingURL=upsellMessageDismiss.epics.js.map
